import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-icon"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M20 10V7L15 2H4V22H20M14 2V8H20","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 13V19M11 19H10.5C9.94772 19 9.5 18.5523 9.5 18V14C9.5 13.4477 9.94772 13 10.5 13H11M19 19V13H21C21.5523 13 22 13.4477 22 14V19M13.5 14V18C13.5 18.5523 13.9477 19 14.5 19H15.5C16.0523 19 16.5 18.5523 16.5 18V14C16.5 13.4477 16.0523 13 15.5 13H14.5C13.9477 13 13.5 13.4477 13.5 14Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileIcon = Vue.extend<IconProps>({
  name: 'FileIconIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'file-icon',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default FileIcon;
